// src/hooks/usePrintManagement.js
import { useCallback } from 'react';
import config from '../config';

const host = config.backendUrl;

export default function usePrintManagement({
  order,
  luluIds,
  setLuluIds,
  authToken,
}) {
  const sendToPrinter = useCallback(
    (itemIndex) => {
      if (!order || !order.id) return;

      const confirmSend = () => {
        if (itemIndex === -1) {
          const someSent = order.items.some((item) => item.status === 'sent_to_printer');
          return window.confirm(someSent
            ? 'One or more items have already been sent to print.\n\nAre you sure you want to send all items again?'
            : 'Are you sure you want to send all items to the printer?');
        } else {
          const itemSent = order.items[itemIndex].status === 'sent_to_printer';
          return window.confirm(itemSent
            ? 'This item has already been sent to print.\n\nAre you sure you want to send it again?'
            : 'Are you sure you want to send this item to the printer?');
        }
      };

      if (!confirmSend()) return;

      fetch(`${host}/api/admin/send-to-printer/${order.id}/${itemIndex}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data.message);
          if (data.status === 'success') {
            if (itemIndex === -1) {
              order.items.forEach((item) => (item.status = 'sent_to_printer'));
            } else {
              order.items[itemIndex].status = 'sent_to_printer';
            }
          }
        })
        .catch((err) => console.error('Error sending to printer:', err));
    },
    [order, authToken]
  );

  const cancelPrintJob = useCallback(
    (itemIndex) => {
      if (!order || !order.id) return;

      const multipleJobs = !luluIds.every((id) => id === luluIds[0] && id !== null && id !== undefined);

      const confirmCancel = () => {
        if (itemIndex === -1) {
          return window.confirm(multipleJobs
            ? 'There are multiple print jobs connected to this order. Are you sure you would like to cancel all of them?'
            : 'Are you sure you want to cancel the print job containing all items in this order?');
        } else if (["in_production", "shipped"].includes(order.items[itemIndex].status)) {
          alert('This item is already in production or has been shipped.');
          return false;
        } else {
          return true;
        }
      };

      if (!confirmCancel()) return;

      fetch(`${host}/api/admin/cancel-print-job/${order.id}/${itemIndex}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data.message);
          if (data.status === 'success') {
            if (itemIndex === -1) {
              order.items.forEach((item) => (item.status = 'print_cancelled'));
              order.status = 'print_cancelled';
            } else {
              order.items[itemIndex].status = 'print_cancelled';
              if (luluIds[itemIndex] !== null && luluIds[itemIndex] !== undefined) {
                setLuluIds((prev) => {
                  const updated = [...prev];
                  updated[itemIndex] = null;
                  return updated;
                });
              }
            }
          }
        })
        .catch((err) => console.error('Error cancelling print job:', err));
    },
    [order, luluIds, authToken, setLuluIds]
  );

  return {
    sendToPrinter,
    cancelPrintJob,
  };
}